/** Routes publiques autonomes (sans shell CRM / choix d'application). */
export function isStandalonePublicRoute(pathname = '') {
  return pathname.startsWith('/lp/');
}
